<header class="header">
  <div class="header-left">
    <button class="mobile-menu-toggle" (click)="sidebarService.toggle()">
      <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M4 6h16M4 12h16M4 18h16"
        />
      </svg>
    </button>
    <h1 class="page-title">{{ titleService.pageTitle() }}</h1>
  </div>

  <div class="header-right">
    @if (!isAdmin()) {
      <div class="credit-limit-container">
        <div class="credit-limit-value">
          <span class="amount">{{ creditLimit() | number }}</span>
          <span class="currency">฿</span>
        </div>
      </div>
    }

    <div class="user-info">
      <div class="user-avatar">{{ userInitials() }}</div>
      <div class="user-details">
        <div class="user-name">{{ userName() }}</div>
        <div class="user-email">{{ userEmail() }}</div>
      </div>
    </div>
  </div>
</header>
